<template>
   <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="true"
  >
    <template #subHeaderActions>
      <div class="d-flex align-items-center gap-2 gap-lg-3">
      </div>
    </template>

    <template #customLayoutContent>
      <div class="m-10">
        <Card class="card p-5"  containerClass="mb-5">

          <div class="row px-5">
              <div id="payslip-container" class="col-12 col-md-6 mx-auto">
                <br>
                <Card class="card p-5" :title="$t('payslip.file.title')">
                  <table class="light_blue">
                    <thead>
                    <tr>
                      <th class="text-center" style="width: 30%"> <h2 >{{ $t('payslip.file.info') }}</h2> </th>
                      <th class="bg_white"></th>
                      <th class="text-center" style="width: 30%"> <h2 >{{ $t('payslip.file.bulletin_paie') }}</h2> </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td> <p>{{ $t('payslip.file.matricule') }} : {{ payslip?.employee?.social_security_number }}</p> </td>
                      <th class="bg_white"></th>
                      <td class="text-center"> <p class="mois">{{ $t('payslip.file.mois') }}: {{ getMonthName(payslip?.month) }} {{ payslip?.year }}</p> </td>
                    </tr>
                    <tr>
                      <td> <p>{{ $t('payslip.file.service') }}</p> </td>
                      <th class="bg_white"></th>
                      <td> <p>{{ $t('payslip.file.name') }}: {{ payslip?.employee?.firstname }} {{ payslip?.employee?.lastname }}</p> </td>
                    </tr>
                    <tr>
                      <td> <p>{{ $t('payslip.file.emploi') }} : {{ payslip?.employee?.post?.title || '' }}</p> </td>
                      <th class="bg_white"></th>
                      <td> <p>{{ $t('payslip.file.sexe') }}: {{ payslip?.employee?.gender }}</p> </td>
                    </tr>
                    <tr>
                      <td> <p>{{ $t('payslip.file.statut') }}: {{ payslip?.employee?.active }}</p> </td>
                      <th class="bg_white"></th>
                      <td> <p>{{ $t('payslip.file.situ_matri') }}: {{ payslip?.employee?.family_status }}</p> </td>
                    </tr>
                    <tr>
                      <td> <p>{{ $t('payslip.file.taux_prevu') }}</p> </td>
                      <th class="bg_white"></th>
                      <td> <p>{{ $t('payslip.file.adresse') }}: {{ payslip?.employee?.address }}</p> </td>
                    </tr>
                    <tr>
                      <td> <p>{{ $t('payslip.file.salaire_categ') }}:  {{ payslip?.employee?.post_category }}</p> </td>
                      <th class="bg_white"></th>
                      <th class="bg_white"></th>
                    </tr>
                    <tr>
                      <td> <p>{{ $t('payslip.file.horaire_moy_mens') }}</p> </td>
                      <th class="bg_white"></th>
                      <th class="bg_white"></th>
                    </tr>
                    <tr>
                      <td> <p>{{ $t('payslip.file.date_entree') }} : {{ payslip?.employee?.date_in_service }}</p> </td>
                      <th class="bg_white"></th>
                      <th class="bg_white"></th>
                    </tr>
                    </tbody>
                  </table>
                  <div>
                    <table class="table table-rounded border  gs-7">
                      <thead>
                        <tr class="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                          <th colspan="3" class="fs-3 fw-bold text-center light_blue">{{ $t('payslip.file.rubriques') }}</th>
                          <th class="text-center fs-3 fw-bold light_blue" style="vertical-align: middle;" rowspan="2">{{ $t('payslip.file.tx_salarial') }}</th>
                          <th class="text-center fs-3 fw-bold light_blue">{{ $t('payslip.file.part_salariale') }}</th>
                        </tr>
                        <tr class="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                          <th colspan="3" class="fs-3 fw-bold light_blue">{{ $t('payslip.file.libelle') }}</th>
                          <th class="text-center fs-3 fw-bold light_blue">{{ $t('payslip.file.a_payer') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td colspan="3">
                          <p>{{ $t('payslip.file.base_mensuelle') }}</p>
                          <p class="fs-4 fw-bold text-end">{{ $t('payslip.file.total_mois') }}</p>
                        </td>
                        <td class="valeur text-center">-</td>
                        <td class="valeur text-center">
                          <p>{{ formatAmount(payslip?.base_salary) }}</p>
                          <p class="fs-4 fw-bold text-end">{{ formatAmount(payslip?.base_salary) }}</p>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="3">
                          <p v-for="(other, index) in payslip.others" :key="'other-title-'+index">
                            {{ other.title }}
                          </p>
                          <p class="fs-4 fw-bold text-end">{{ $t('payslip.file.total_primes') }}</p>
                        </td>
                        <td class="valeur text-center">-</td>
                        <td class="valeur text-center">
                          <p v-for="(other, index) in payslip.others" :key="'other-value-'+index">
                            {{ formatAmount(other.pivot?.value) }}
                          </p>
                          <p class="fs-4 fw-bold text-end"> {{ formatAmount(payslip?.total_others) }}</p>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="3">
                          <p v-for="(allowance, index) in payslip.allowances" :key="'allowance-title-'+index">
                            {{ allowance?.title }}
                          </p>
                          <p class="fs-4 fw-bold text-end">{{ $t('payslip.file.total_indemnites') }}</p>
                        </td>
                        <td class="valeur text-center">-</td>
                        <td class="valeur text-center">
                          <p v-for="(allowance, index) in payslip.allowances" :key="'allowance-value-'+index">
                            {{ formatAmount(allowance.pivot?.value) }}
                          </p>
                          <p class="fs-4 fw-bold text-end"> {{ formatAmount(payslip?.total_allowances) }}</p>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="3" class="fs-4 fw-bold text-end">{{ $t('payslip.file.salaire_brut_mois') }}</td>
                        <td class="valeur text-end"></td>
                        <td class="valeur text-center">
                          <p class="fs-4 fw-bold text-end"> {{ formatAmount(payslip?.brut_salary) }}</p>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="3">
                          <p v-for="(pension, index) in payslip.pensions"  :key="'pension-title-'+index">
                            <span v-if="pension?.category === pensionTypesEnums.EMPLOYEE_PENSION">
                              {{ pension?.title }}
                            </span>
                          </p>
                          <p class="fs-4 fw-bold text-end">{{ $t('payslip.file.total_retenues') }}</p>
                          <p v-for="(tax, index) in payslip.taxes" :key="'tax-title-'+index">
                            <span v-if="tax?.category === payrollTaxStatusEnums.EMPLOYEE_TAXE">
                              {{ tax?.title }}
                            </span>
                          </p>
                          <p class="fs-4 fw-bold text-end">{{ $t('payslip.file.total_taxes') }}</p>
                        </td>
                        <td class="valeur text-center">-</td>
                        <td class="valeur text-center">
                          <p v-for="(pension, index) in payslip.pensions" :key="'pension-value-'+index">
                            <span v-if="pension?.category === pensionTypesEnums.EMPLOYEE_PENSION">
                              {{ formatAmount(pension.pivot?.value) }}
                            </span>
                          </p>
                          <p class="fs-4 fw-bold text-end"> {{ formatAmount(payslip?.total_pensions) }}</p>
                          <p v-for="(tax, index) in payslip.taxes" :key="'tax-value-'+index">
                            <span v-if="tax?.category === payrollTaxStatusEnums.EMPLOYEE_TAXE">
                              {{ formatAmount(tax.pivot?.value) }}
                            </span>
                          </p>
                          <p class="fs-4 fw-bold text-end"> {{ formatAmount(payslip?.total_taxes) }}</p>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="3">
                          <p>{{ $t('payslip.file.sous_total') }}</p>
                          <p class="fs-4 fw-bold text-end">{{ $t('payslip.file.total_apres_retenues') }}</p>
                        </td>
                        <td class="valeur text-center">-</td>
                        <td class="valeur text-center">
                          <p> {{ formatAmount(payslip?.total_deductions) }} </p>
                          <p> {{ formatAmount(parseFloat(payslip?.total_deductions) + parseFloat(payslip?.brut_salary)) }} </p>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="3">
                          <p class="fs-4 fw-bold text-end">{{ $t('payslip.file.net_a_payer') }}</p>
                        </td>
                        <td class="valeur text-end"></td>
                        <td class="valeur text-center">
                          <p class="fs-4 fw-bold text-end"> {{ formatAmount(payslip?.net_salary) }} </p>
                        </td>
                      </tr>

                      <tr >
                        <td colspan="3" class=" text-start" >
                        </td>
                        <td class="fs-4 fw-bold light_blue" style="text-align: center">Total</td>
                        <td class="light_blue">
                          <p class="fs-4 fw-bold text-end">{{ formatAmount(payslip?.paid_salary) }}</p>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </Card>
              </div>
              <div class="col-12 col-md-1 d-flex flex-column align-items-center pt-8">
                  <div class="card w-100">
                      <div class="d-flex flex-wrap justify-content-center">
                        <Button btn-class="me-3 mb-5 btn-sm" @click.prevent="printButton" :title="$t('crm.invoices.print')" icon-class="fas fa-print" type="new"></Button>
                      </div>
                    <div class="d-flex flex-wrap justify-content-center">
                      <Button btn-class="me-3 mb-5 btn-sm" @click.prevent="downloadPayslip" :title="$t('crm.invoices.download')" icon-class="fas fa-download" type="new"></Button>
                    </div>
                  </div>
              </div>
          </div>
        </Card>

      </div>
    </template>
    </SubLayout>
</template>

<script setup>

import {ref,onMounted, watch} from "vue";
import {useStore} from "vuex";
import Card from "@/Modules/CRM/components/Card";
import { useFormatAmount } from "@/composables/formatAmount";
import { computed } from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import { useRoute } from "vue-router";
import Button from "@/components/Button.vue";
import { useLocales } from "@/composables/locales";
import i18n from "@/plugins/i18n";
import {getMonthLocalName} from "@/mixins/Helpers";
import {usePayslipEnums} from "@/Modules/RH/composables/payslipEnums";

const title = ref("breadcrumbs.payslip.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.payslip.file',
    path: '/file'
  }
])

const {locale} = useLocales()
const route = useRoute()
const store = useStore()
const payslip = ref({})

const { formatAmount } = useFormatAmount()
const { pensionTypesEnums, payrollTaxStatusEnums } = usePayslipEnums()

const currentSociety = computed(() => store.getters['offices/getSelectedCompany'])



async function getPayslip(){
  try {
        store.dispatch('payslip/getPayslip', route.params.id).then(resp => {
          payslip.value = resp.data.data
        })
      } catch (e) {
      }
}

function getMonthName(monthNumber) {
  return new Date(2000, monthNumber - 1).toLocaleString(locale, { month: 'long' });
}

function downloadPayslip () {
  let data = {
    payslip: route.params.id,
  }
  store.dispatch('payslip/downloadPayslips', data)
      .then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));
        const link = document.createElement('a');
        let tmp = payslip.value.employee.fullname.replace(' ', '-')
        link.href = url;
        link.setAttribute(
            'download',
            `${i18n.global.t('payslip.filename')}-${tmp}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .finally(() => {})
}

function printButton() {
  let prtHtml1 = document.getElementById('payslip-container');
  let WinPrint = window.open('', 'Print-Window', 'left=0,top=0,width=800,height=900,toolbar=1,scrollbars=0,status=0');
  let modals = prtHtml1.getElementsByClassName('modal')
  modals.forEach(el => el.style.display = 'none')
  WinPrint.document.write(`<!DOCTYPE html>
        <html>
        <head>
            <style>
                @page {
                    size: A4;
                    margin: 0;
                }
                body, html {
                    margin: 0;
                    font-family: 'Poppins', Helvetica, sans-serif;
                    font-size: 13px;
                    color: #181c32;
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                    width: 100%;
                    height: 100%;
                    padding: 0;
                    box-sizing: border-box;
                    background-color: #F2F3F4;
                }
                .content {
                    padding: 30px;
                    box-sizing: border-box;
                    min-height: calc(100% - 150px); /* Adjust for footer height */
                }
                h2 {
                    font-size: 12px;
                }
                h2, h5, h4 {
                    margin: 0;
                }
                table {
                  width: 100%;
                  border-collapse: collapse;
                }
                table.light_blue {
                  margin-top: 10px;
                  margin-bottom: 10px;
                }
                table.light_blue td, table.light_blue th {
                  background-color: #0072CE0D !important;
                }
                table.light_blue td.bg_white, table.light_blue th.bg_white {
                  background-color: white !important;
                }
                table.light_blue th {
                  padding: 10px
                }
                table.light_blue td {
                  padding: 0 10px;
                }

                table td.light_blue, table td.light_blue {
                  background-color: #0072CE0D !important;
                }

                .table td, .table th, .table tr {
                  border-style: solid !important;
                  border-width: 1px !important;
                  border-color: #0072CE !important; /* Ajoute une bordure */
                }


                .border {
                    border: 1px solid #0072CE !important;
                }

                .table.table-rounded {
                  border-radius: .475rem;
                  border-spacing: 0;
                  border-collapse: separate;
                }

                .table > thead {
                  vertical-align: bottom;
                }

                .table > thead {
                  vertical-align: bottom;
                }

                .table > thead {
                  vertical-align: bottom;
                }

                .table > thead {
                  vertical-align: bottom;
                }

                .fs-6 {
                  font-size: 1.075rem !important;
                }


                .fw-bold {
                  font-weight: 500 !important;
                }


            </style>
        </head>
        <body>
            <div class="content">
                ${prtHtml1.innerHTML}
            </div>
        </body>
        </html>`);

  WinPrint.document.close();
  WinPrint.focus();

  setTimeout(() => {
    WinPrint.print();
    WinPrint.close();
  }, 1000);
}

watch(()=> route.params.id, () => {
  if(route.params.id){
    getPayslip()
  }
})


onMounted(() => {
  if(route.params.id){
    getPayslip()
  }
})

</script>
<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
table.light_blue {
  margin-top: 10px;
  margin-bottom: 10px;
}
table.light_blue td, table.light_blue th {
  background-color: #0072CE0D !important;
}
table.light_blue td.bg_white, table.light_blue th.bg_white {
  background-color: white !important;
}
table.light_blue th {
  padding: 10px
}
table.light_blue td {
  padding: 0 10px;
}

table td.light_blue, table td.light_blue {
  background-color: #0072CE0D !important;
}

.table td, .table th, .table tr {
  border-style: solid !important;
  border-width: 1px !important;
  border-color: #0072CE !important; /* Ajoute une bordure */
}


.border {
    border: 1px solid #0072CE !important;
}
</style>